import React from 'react';
import { useNavigate } from 'react-router-dom';
import { compose } from 'recompose';
import {
  renderWhileLoadingTwoQueries,
  setRefetchProp,
  renderForErrorCreateTransfer
} from '../../../state/apolloRecompose';
import CreateTransfer from './CreateTransfer';

// Enhancers
import withNameState from './enhancers/states/withNameState';
import withTransactionsState from './enhancers/states/withTransactionsState';
import withValidationState from './enhancers/states/validationState';
import withModalState from './enhancers/states/withModalState';
import withAccountHolderTypeState from './enhancers/states/withAccountHolderTypeState';
import withCurrencyState from './enhancers/states/withCurrencyState';
import withLoadingModal from './enhancers/states/withLoadingModalState';
import withSuccessState from './enhancers/states/withSuccessState';
import withErrorState from './enhancers/states/withErrorState';
import withWarningState from './enhancers/states/withWarningState';
import withBatchWarningState from './enhancers/states/withBatchWarningState';
import withBatchProgressState from './enhancers/states/withBatchProgressState';

import withSubscriptionQuery from './enhancers/withSubscriptionQuery';
import withLimitsQuery from './enhancers/withLimitsQuery';

import withCreateTransferMutation from './enhancers/mutations/withCreateTransferMutation';

import withHandlers from './enhancers/withHandlers';

const ComposedCreateTransfer = compose(
  withTransactionsState,
  withAccountHolderTypeState,
  withSuccessState,
  withErrorState,
  withWarningState,
  withBatchWarningState,
  withNameState,
  withModalState,
  withValidationState,
  withCurrencyState,
  withLoadingModal,
  withBatchProgressState,
  withSubscriptionQuery,
  withLimitsQuery,
  withCreateTransferMutation,
  withHandlers,
  renderWhileLoadingTwoQueries,
  setRefetchProp,
  renderForErrorCreateTransfer
)(CreateTransfer);

// Wrapper to inject navigate as history prop for compatibility with withHandlers
export default function CreateTransferWrapper(props) {
  const navigate = useNavigate();

  // Create history-like object with push method for compatibility
  const history = {
    push: (path) => navigate(path)
  };

  return <ComposedCreateTransfer {...props} history={history} />;
}
